import { apiCall } from "./api";
import { sortByDistance } from "./turfUtils";
import axios from "axios";

const DEGREE_STEP = 0.002;

export async function getPois(coords) {
    console.time("getApis");
    const bottom = coords.latitude - DEGREE_STEP;
    const top = coords.latitude + DEGREE_STEP;
    const left = coords.longitude - DEGREE_STEP;
    const right = coords.longitude + DEGREE_STEP;
    //const overpassSource = '	https://lz4.overpass-api.de/api/interpreter';
    const overpassSource = "https://overpass.kumi.systems/api/interpreter";

    //const url = `${overpassSource}?data=%0A%5Bout%3Ajson%5D%5Btimeout%3A25%5D%3B%0A%0A%28%0A%0A%20%20nwr%5B%22name%22%5D%5B%22highway%22%21~%22.*%22%5D%5B%22boundary%22%21~%22.*%22%5D%5B%22route%22%21~%22.*%22%5D%5B%22place%22%21~%22.*%22%5D%5B%22public_transport%22%21~%22.*%22%5D%28{bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%0A%29%3B%0A%0Aout%20center%3B%0A`;
    try {
        const url = `${overpassSource}?data=%5Bout%3Ajson%5D%5Btimeout%3A200%5D%3B%0A%0A%28%0A%0A%20%20node%5B%22amenity%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20way%5B%22amenity%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20relation%5B%22amenity%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%0A%20%20node%5B%22leisure%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20way%5B%22leisure%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20relation%5B%22leisure%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%0A%20%20node%5B%22tourism%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20way%5B%22tourism%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20relation%5B%22tourism%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%0A%20%20node%5B%22historic%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20way%5B%22historic%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20relation%5B%22historic%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%0A%20%20node%5B%22shop%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20way%5B%22shop%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20relation%5B%22shop%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%0A%20%20node%5B%22office%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20way%5B%22office%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%20%20relation%5B%22office%22%5D%28${bottom}%2C${left}%2C${top}%2C${right}%29%3B%0A%29%3B%0A%0Aout%20center%3B`;
        const response = await axios.get(url);
        console.timeEnd("getApis");

        return response.data.elements;
    } catch (err) {
        console.log(err);
    } finally {
        console.log("finished");
    }
}

export async function getPoisFromRoute4U(coords) {
    const params = new URLSearchParams({
        tags: "tourism, historic,leisure,amenity,shop,office",
        bottomLeft:
            coords.latitude -
            DEGREE_STEP +
            "," +
            (coords.longitude - DEGREE_STEP),
        topRight:
            coords.latitude +
            DEGREE_STEP +
            "," +
            (coords.longitude + DEGREE_STEP),
    });
    const options = {
        service: "search/overpass",
        params,
        lang: "en",
    };

    try {
        const data = await apiCall(options);
        const sortedPois = sortByDistance(coords, data.result);
        return sortedPois;
    } catch (err) {
        console.log(err);
    } finally {
        console.log("finished");
    }
}
